import { render, staticRenderFns } from "./ProfileIconActive.vue?vue&type=template&id=30f5ad33&scoped=true"
import script from "./ProfileIconActive.vue?vue&type=script&lang=js"
export * from "./ProfileIconActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5ad33",
  null
  
)

export default component.exports